import { N62 } from "./SalesPerfSummary/N62"
import { N30 } from "./ShareByRegion/N30"
import { N31 } from "./ShareByDistrict/N31"
import { N34 } from "./ActualTarget/N34"
import { N33 } from "./ActualLastYear/N33"
import { N68 } from "./SalesPerformanceByDM/N68"
import { N68_12 } from "./DistrictComparativeMonthly/N68_12"
import { N32 } from "./SalesPeformancePMR/N32"
import { N68_04 } from "./EmployeeComparativeSales/N68_04"
import { N68_05 } from "./EmployeeGrowthPerformance/N68_05"
import { N68_21 } from "./DistrictGroupPerformance/N68_21"

export const ComparativeSalesPerformance = {
  "sections": [
    N62,
    N30,
    N31,
    N34,
    N33,
    N68,
    N68_12,
    N32,
    N68_04,
    N68_05,
    N68_21
  ]
}